<div
  [ngClass]="{ hidden: currentStep !== info.step }"
  class="flex flex-col divide-y w-full h-full"
>
  <div class="grid grid-cols-3 items-center mb-2">
    <div class="flex items-center">
      @if (info.backButton) {
        <confect-icon-button
          (click)="back.emit()"
          icon="chevron_left"
          iconClass="text-2xl"
          >{{ info.backButton }}</confect-icon-button
        >
      }
    </div>
    <div class="flex flex-col items-center justify-center text-center">
      @if (info.title) {
        <h4 class="cursor-default">{{ info.title }}</h4>
      }
      @if (!valid) {
        <div class="text-red">{{ invalidText }}</div>
      }
    </div>

    <div class="flex items-center justify-end gap-2">
      @if (info.secondaryButton) {
        <confect-button
          [type]="info.secondaryType ?? 'white'"
          [disabled]="!valid"
          (click)="secondary.emit()"
          >{{ info.secondaryButton }}</confect-button
        >
      }
      @if (info.primaryButton) {
        <confect-button
          [type]="info.primaryType ?? 'primary'"
          [disabled]="!valid"
          (click)="next.emit()"
          >{{ info.primaryButton }}</confect-button
        >
      }
    </div>
  </div>
  <div class="pt-5 w-full" [style.height]="'calc(100% - 2.25rem)'">
    <ng-content />
  </div>
</div>
